// Import our CSS
import "@/scss/app.scss";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */

import { menu } from "./components/menu.js";
import Alpine from "alpinejs";
import AOS from "aos";
import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";
import { scrollLink } from "./components/scrollLink.js";

Alpine.plugin(collapse);
Alpine.plugin(intersect);

window.addEventListener("load", (event) => {
    AOS.init({
        once: "true",
    });
});

window.Alpine = Alpine;
Alpine.start();
menu();
scrollLink();

// animation
AOS.init();

window.getCookie = function(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}